import type { UrlEntry, UrlRegion } from '@/types';

export type SyllabusPages =
  | 'syllabus/cy'
  | 'syllabus/da'
  | 'syllabus/ux'
  | 'syllabus/wd'
  | 'syllabus/ml'
  | 'syllabus/ai'
  | 'syllabus/dv'
  | 'syllabus/mk';

export const isIndexable = false;

export const urls: Record<
  SyllabusPages,
  Partial<Record<UrlRegion, UrlEntry>>
> = {
  'syllabus/ai': {
    de: 'kunstliche-intelligenz/syllabus',
    'de-en': 'artificial-intelligence/syllabus',
    es: 'inteligencia-artificial/plan-de-estudios',
    'es-en': 'artificial-intelligence/syllabus',
    fr: 'intelligence-artificielle/syllabus',
    'fr-en': 'artificial-intelligence/syllabus',
    gb: 'artificial-intelligence/syllabus',
    nl: 'kunstmatige-intelligentie/curriculum',
    'nl-en': 'artificial-intelligence/syllabus',
    pt: 'inteligencia-artificial/plano-de-estudos',
    'pt-en': 'artificial-intelligence/syllabus',
    ww: 'artificial-intelligence/syllabus',
  },
  'syllabus/cy': {
    de: 'cybersecurity/syllabus',
    'de-en': 'cybersecurity/syllabus',
    es: 'ciberseguridad/plan-de-estudios',
    'es-en': 'cybersecurity/syllabus',
    fr: 'cybersecurite/syllabus',
    'fr-en': 'cybersecurity/syllabus',
    gb: 'cybersecurity/syllabus',
    nl: 'cybersecurity/curriculum',
    'nl-en': 'cybersecurity/syllabus',
    pt: 'ciberseguranca/plano-de-estudos',
    'pt-en': 'cybersecurity/syllabus',
    ww: 'cybersecurity/syllabus',
  },
  'syllabus/da': {
    de: 'data-analytics/syllabus',
    'de-en': 'data-analytics/syllabus',
    es: 'data-analytics/plan-de-estudios',
    'es-en': 'data-analytics/syllabus',
    fr: 'data-analytics/syllabus',
    'fr-en': 'data-analytics/syllabus',
    gb: 'data-analytics/syllabus',
    nl: 'data-analytics/curriculum',
    'nl-en': 'data-analytics/syllabus',
    pt: 'data-analytics/plano-de-estudos',
    'pt-en': 'data-analytics/syllabus',
    us: 'data-analytics/syllabus',
    ww: 'data-analytics/syllabus',
  },
  'syllabus/dv': {
    de: 'devops-cloud-computing/syllabus',
    'de-en': 'devops-cloud-computing/syllabus',
    es: 'devops-cloud-computing/plan-de-estudios',
    'es-en': 'devops-cloud-computing/syllabus',
    fr: 'devops-cloud-computing/syllabus',
    'fr-en': 'devops-cloud-computing/syllabus',
    gb: 'devops-cloud-computing/syllabus',
    nl: 'devops-cloud-computing/curriculum',
    'nl-en': 'devops-cloud-computing/syllabus',
    pt: 'devops-cloud-computing/plano-de-estudos',
    'pt-en': 'devops-cloud-computing/syllabus',
    ww: 'devops-cloud-computing/syllabus',
  },
  'syllabus/mk': {
    de: 'digital-marketing/syllabus',
    'de-en': 'digital-marketing/syllabus',
    es: 'marketing-digital/plan-de-estudios',
    'es-en': 'digital-marketing/syllabus',
    fr: 'marketing-digital/syllabus',
    'fr-en': 'digital-marketing/syllabus',
    gb: 'digital-marketing/syllabus',
    nl: 'digital-marketing/curriculum',
    'nl-en': 'digital-marketing/syllabus',
    pt: 'marketing-digital/plano-de-estudos',
    'pt-en': 'digital-marketing/syllabus',
    ww: 'digital-marketing/syllabus',
  },
  'syllabus/ml': {
    de: 'data-science-machine-learning/syllabus',
    'de-en': 'data-science-machine-learning/syllabus',
    es: 'data-science-machine-learning/plan-de-estudios',
    'es-en': 'data-science-machine-learning/syllabus',
    fr: 'data-science-machine-learning/syllabus',
    'fr-en': 'data-science-machine-learning/syllabus',
    gb: 'data-science-machine-learning/syllabus',
    nl: 'data-science-machine-learning/curriculum',
    'nl-en': 'data-science-machine-learning/syllabus',
    pt: 'data-science-machine-learning/plano-de-estudos',
    'pt-en': 'data-science-machine-learning/syllabus',
    ww: 'data-science-machine-learning/syllabus',
  },
  'syllabus/ux': {
    de: 'ux-ui-design/syllabus',
    'de-en': 'ux-ui-design/syllabus',
    es: 'diseno-ux-ui/plan-de-estudios',
    'es-en': 'ux-ui-design/syllabus',
    fr: 'ux-ui-design/syllabus',
    'fr-en': 'ux-ui-design/syllabus',
    gb: 'ux-ui-design/syllabus',
    nl: 'ux-ui-design/curriculum',
    'nl-en': 'ux-ui-design/syllabus',
    pt: 'ux-ui-design/plano-de-estudos',
    'pt-en': 'ux-ui-design/syllabus',
    us: 'ux-ui-design/syllabus',
    ww: 'ux-ui-design/syllabus',
  },
  'syllabus/wd': {
    de: 'webentwicklung/syllabus',
    'de-en': 'web-development/syllabus',
    es: 'desarrollo-web/plan-de-estudios',
    'es-en': 'web-development/syllabus',
    fr: 'developpement-web/syllabus',
    'fr-en': 'web-development/syllabus',
    gb: 'web-development/syllabus',
    nl: 'web-development/curriculum',
    'nl-en': 'web-development/syllabus',
    pt: 'programacao-web/plano-de-estudos',
    'pt-en': 'web-development/syllabus',
    us: 'web-development/syllabus',
    ww: 'web-development/syllabus',
  },
};
